export default {
  // //----- Dev Firebase Account
  apiKey: "AIzaSyC_6gJFxi5u6NLjQzaF5kxZe79B49Gja9c",
  authDomain: "gifuiz.firebaseapp.com",
  databaseURL: "https://gifuiz.firebaseio.com",
  projectId: "gifuiz",
  storageBucket: "gifuiz.appspot.com",
  messagingSenderId: "733543139978",
  appId: "1:733543139978:web:ba4c3cbee6231ab5387b73",
  measurementId: "G-2FRDHPT6LJ",
};
